import React, { useEffect, useRef } from "react";
import ErrorMessage from "../Elements/ErrorMessage/ErrorMessage";
import SuccessMessage from "../Elements/SuccessMessage/SuccessMessage";

const AffiliationModalStatus = ({ error, success, onErrorClose, onSuccessClose }) => {
  const statusRef = useRef(null);
  const hasStatus = Boolean(error || success);

  useEffect(() => {
    if (hasStatus) statusRef.current?.scrollIntoView({ behavior: "smooth", block: "nearest" });
  }, [error, success, hasStatus]);

  if (!hasStatus) return null;

  return (
    <div ref={statusRef}>
      {error && <ErrorMessage message={error} onClose={onErrorClose} />}
      {success && <SuccessMessage message={success} onClose={onSuccessClose} />}
    </div>
  );
};

export default AffiliationModalStatus;
